import { APP_INSTALLER_REFERRAL_INFO, LOGIN_LINK } from '../consts';
export const redirectToLogin = () => {
  const url = new URL(LOGIN_LINK);
  const currentUrl = window.location.href;
  url.searchParams.set('loginDialogContext', 'login');
  url.searchParams.set('referralInfo', APP_INSTALLER_REFERRAL_INFO);
  url.searchParams.set('postLogin', currentUrl);
  url.searchParams.set('postSignUp', currentUrl);
  window.location.assign(url.href);
};
//# sourceMappingURL=login.js.map